<!-- 偏好设置 -->
<template>
    <div class="setting">
        <div class="content-main">
            <div class="top-info">
                <a-button class="back-btn" @click="goBack">
                    <template #icon>
                        <icon-left/>
                    </template>
                </a-button>
                <span>{{ $t('personal.preferences') }}</span>
            </div>
            <div class="recommendInvite-content">
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.language') }}</span></div>
                    <a-select v-model="selectedLang"
                              class="input"
                              size="large" long
                              @change="onLangChange">
                        <a-option value="zh_CN">{{ $t('language.native_simplified_chinese') }}</a-option>
                        <a-option value="zh_Hant">{{ $t('language.native_traditional_chinese') }}</a-option>
                        <a-option value="en-US">English</a-option>
                        <a-option value="fr">Français</a-option>
                        <a-option value="es">Español</a-option>
                        <a-option value="vi">Tiếng Việt</a-option>
                        <a-option value="ja">{{ $t('language.native_japanese') }}</a-option>
                        <a-option value="ko">한국어</a-option>
                        <a-option value="gm">Deutsch</a-option>
                        <a-option value="ru">Русский</a-option>
                        <a-option value="th">ไทย</a-option>
                        <a-option value="au">{{ $t('language.native_australian_english') }}</a-option>
                    </a-select>
                </div>
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.currency') }}</span></div>
                    <a-select v-model="selectedCurrency"
                              class="input"
                              size="large" long
                              :loading="currencySwitching"
                              :disabled="currencySwitching"
                              @change="onCurrencyChange">
                        <a-option
                            v-for="item in currencyOptions"
                            :key="item.code"
                            :value="item.code"
                        >
                            {{ $t(item.labelKey) }}
                        </a-option>
                    </a-select>
                </div>
                <div class="recommendInvite-content-box">
                    <a-button class="confirm"
                              @click="handleOk">
                        {{ $t('personal.confirm') }}
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {DISPLAY_CURRENCIES} from '@/common/constants/displayCurrencies';

export default {
    components: {},
    data() {
        return {
            selectedLang: this.$util.getCache('lang') || 'en-US',
            selectedCurrency: this.$store.getters.displayCurrency.code,
            currencyOptions: DISPLAY_CURRENCIES,
            currencySwitching: false
        };
    },
    computed: {
        displayCurrencyCode() {
            return this.$store.getters.displayCurrency.code;
        }
    },
    watch: {
        displayCurrencyCode(code) {
            this.selectedCurrency = code;
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        onLangChange(value) {
            console.log('🌐 用户设置页面语言切换:', value);
            this.$util.setCache('lang', value);
            this.$i18n.locale = value;
            this.$message.success(this.$util.getI18nText('language_setting_saved', 'Language setting saved'));
        },
        async onCurrencyChange(value) {
            if (this.currencySwitching) {
                return;
            }

            console.log('💰 用户设置页面货币切换:', value);
            this.currencySwitching = true;
            try {
                await this.$store.dispatch('switchDisplayCurrency', value);
                this.selectedCurrency = this.$store.getters.displayCurrency.code;
                this.$message.success(this.$t('personal.currency_setting_saved'));
            } catch (error) {
                this.selectedCurrency = this.$store.getters.displayCurrency.code;
                console.error('用户设置页汇率切换失败:', error);
                this.$message.error(this.$t('common.operation_failed_retry'));
            } finally {
                this.currencySwitching = false;
            }
        },
        handleOk() {
            this.$message.success(this.$util.getI18nText('setting_saved', 'Settings saved'));
            this.$router.go(-1);
        }
    },
};
</script>
<style lang="scss" scoped>
@import "./userSettings.scss";
</style>
